import * as React from "react";
import { FC } from "react";
import { Edit, EditProps } from "react-admin";
import AircraftEditForm from "./Forms/AircraftEditForm";
import { TitleAircraft } from "./Constant/Source";

const AircraftEdit: FC<EditProps> = props => {
  return (
    <Edit {...props} title={TitleAircraft.edit} component="div">
      <AircraftEditForm {...props} />
    </Edit>
  );
};

export default AircraftEdit;
